import doMetric from '../tracking/bigQueryMetricRecorder';
import Track from '../utils/tracking';
import * as actionTypes from './action-types';
import MarketingPreferenceType from '../../enums/MarketingPreferenceType';
import * as CheckoutAPIActions from './APIActions/CheckoutAPIActions';

export const updateEmailAddress = emailAddress => ({
  type: actionTypes.UPDATE_EMAIL_ADDRESS,
  emailAddress,
});

export const setMarketingPreference = optedIntoMarketing => ({
  type: actionTypes.SET_MARKETING_PREFERENCE,
  optedIntoMarketing,
});

export const setShowMarketingPreferences = displayType => ({
  type: actionTypes.SET_SHOW_MARKETING_PREFERENCE,
  displayType,
});

export const checkEmailWithAPI = email => dispatch => (
  dispatch(CheckoutAPIActions.getMarketingPreferences({email}))
    .then(displayType => displayType.msg.marketingPreferenceType)
    .catch(() => MarketingPreferenceType.NONE)
    .then((displayType) => {
      dispatch(setShowMarketingPreferences(displayType));
      try {
        doMetric('shouldShowMarketingPreferencesForEmail',
          [{name: 'showMarketingPreferences', value: displayType}],
          [], 'impression');
      } catch (error) {
        Track.track(error);
      }
    })
);
